import store from "../../../store";
import conference from './conference.vue';


window.conference =  new Vue({
    store,
    el: '#conference',
    name : "conference",
    created () {

    },
    components : {
        conference
    }
})
